import React from 'react'
const ValidationContext = React.createContext()

export {
  ValidationContext
}